import { X } from "lucide-react";

export default function PriceTemplateViewModal({
  isOpen,
  onClose,
  template,
}) {
  if (!isOpen || !template) return null;

  const product = template.warranty_product;

  const coverageList =
    product?.coverage?.split(".").filter(Boolean) || [];

  const exclusionList =
    product?.exclusions?.split("🚫").filter(Boolean) || [];

  return (
    <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex justify-center items-center p-4">
      <div className="bg-white rounded-3xl w-full max-w-3xl max-h-[90vh] overflow-y-auto shadow-2xl relative">

        {/* ===== HEADER ===== */}
        <div className="sticky top-0 bg-white rounded-t-3xl px-6 py-4 border-b border-slate-100 flex justify-between items-center">
          <h2 className="text-lg font-semibold text-slate-900">
            Price Template Details
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-xl hover:bg-slate-100 transition"
          >
            <X size={18} />
          </button>
        </div>

        {/* ===== BODY ===== */}
        <div className="p-6 space-y-6">

          {/* PRODUCT IMAGE */}
          <div className="flex justify-center">
            <img
              src={product?.image}
              alt={product?.name}
              className="h-48 object-contain rounded-2xl border border-slate-200 bg-slate-50 p-4"
            />
          </div>

          {/* PRODUCT TITLE */}
          <div>
            <h3 className="text-xl font-semibold text-slate-900">
              {product?.name}
            </h3>

            <div className="flex flex-wrap gap-2 mt-2">
              {product?.categories?.map((cat) => (
                <span
                  key={cat.id}
                  className="px-3 py-1 text-xs font-medium bg-blue-50 text-blue-700 rounded-full border border-blue-200"
                >
                  {cat.name}
                </span>
              ))}
            </div>
          </div>

          {/* PRICE SECTION */}
          <div className="bg-slate-50 border border-slate-200 rounded-2xl p-5 grid grid-cols-2 gap-4 text-sm">

            <div>
              <div className="text-slate-500 text-xs">Min Price</div>
              <div className="font-semibold text-slate-900">
                ₹{template.min_price}
              </div>
            </div>

            <div>
              <div className="text-slate-500 text-xs">Max Price</div>
              <div className="font-semibold text-slate-900">
                ₹{template.max_price}
              </div>
            </div>

            <div>
              <div className="text-slate-500 text-xs">Product Price</div>
              <div className="font-semibold text-slate-900">
                ₹{template.product_price}
              </div>
            </div>

            <div>
              <div className="text-slate-500 text-xs">Company Payout</div>
              <div className="font-semibold text-slate-900">
                ₹{template.company_payout}
              </div>
            </div>
          </div>

          {/* PAYOUT SECTION */}
          <div className="bg-indigo-50 border border-indigo-100 rounded-2xl p-5 grid grid-cols-3 gap-4 text-sm">

            <div>
              <div className="text-indigo-500 text-xs">Employee</div>
              <div className="font-semibold text-slate-900">
                ₹{template.emp_payout}
              </div>
            </div>

            <div>
              <div className="text-indigo-500 text-xs">Retailer</div>
              <div className="font-semibold text-slate-900">
                ₹{template.retailer_payout}
              </div>
            </div>

            <div>
              <div className="text-indigo-500 text-xs">Other</div>
              <div className="font-semibold text-slate-900">
                ₹{template.other_payout}
              </div>
            </div>
          </div>

          {/* ===== COVERAGE ===== */}
          <div>
            <h4 className="text-sm font-semibold text-slate-900 mb-3">
              Coverage
            </h4>

            <div className="bg-emerald-50 border border-emerald-100 rounded-2xl p-5 space-y-2">
              {coverageList.map((item, index) => (
                <div
                  key={index}
                  className="flex items-start gap-2 text-sm text-slate-700"
                >
                  <span className="text-emerald-600 mt-0.5">✔</span>
                  <span>{item.trim()}.</span>
                </div>
              ))}
            </div>
          </div>

          {/* ===== EXCLUSIONS ===== */}
          <div>
            <h4 className="text-sm font-semibold text-slate-900 mb-3">
              Exclusions
            </h4>

            <div className="bg-rose-50 border border-rose-100 rounded-2xl p-5 space-y-2">
              {exclusionList.map((item, index) => (
                <div
                  key={index}
                  className="flex items-start gap-2 text-sm text-slate-700"
                >
                  <span className="text-rose-600 mt-0.5">✖</span>
                  <span>{item.trim()}</span>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}